// extracted by mini-css-extract-plugin
module.exports = {"imgSlider":"style_imgSlider__7hjDl","sliderContainer":"style_sliderContainer__qoAbQ"};